import { useRef, useState, useEffect } from 'react';
import ajaxRequest from '../../../../../helpers/ajaxRequest';
import { API, AttraqtSuggestionsResponse } from '../../../../../types';

function useFetch(query: string, open: boolean): AttraqtSuggestionsResponse | null {
  const [data, setData] = useState<null | AttraqtSuggestionsResponse>(null);

  const DEFAULT_SEARCH_QUERY_PARAM = 'defaultsearch';
  const DEBOUNCE_DELAY = 200;

  const cancelRef = useRef<number>();

  useEffect(() => {
    if (!open) {
      setData(null);
      return () => {};
    }

    const queryIsTooShortButNotEmpty = query.length > 0 && query.length < 3;
    if (queryIsTooShortButNotEmpty) {
      return () => {};
    }

    if (query === '') {
      query = DEFAULT_SEARCH_QUERY_PARAM;
    }

    const abortController = new AbortController();

    cancelRef.current = window.setTimeout(() => {
      ajaxRequest({
        method: 'GET',
        url: API.SUGGESTIONS_ATTRAQT,
        data: { searchTerm: query },
        fields: { signal: abortController.signal }
      })
        .then((d) => {
          setData(d);
        })
        .catch((e) => {
          if (e.name !== 'AbortError') {
            setData(null);
          }
        });
    }, DEBOUNCE_DELAY);

    return (): void => {
      abortController.abort();
      clearTimeout(cancelRef.current);
    };
  }, [query, open]);

  return data;
}

export default useFetch;
